<div class="confirmation-body">
  <div *ngIf="!isLoading && quoteConfirmation">
    <div class="text-center">
      <div class="header-line-1">Booking Confirmed</div>
    </div>

    <div class="flex-grow-1 confirmation-message">
      <div class="text-center">
        <div class="mt-2 mb-2">Your booking reference is</div>
        <div class="mt-2 mb-2" style="font-size: 20px">
          <strong>{{ quoteConfirmation.orderNumber }}</strong>
        </div>
        <div>An email confirmation has been sent to</div>
        <div class="mt-2 mb-2" style="font-size: 20px">
          <strong>{{ quoteConfirmation.billingAddressEmail }}</strong
          >.
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="isLoading">
    <span>
      <span class="loading-notice">
        <i class="fa fa-spin fa-2x fa-spinner"></i> &nbsp; Loading
      </span>
    </span>
  </div>
</div>
